<template>
    <div class="list-generator-step-3">

        <p>
            Choose your sample size (the number of items to display in the randomized list)
        </p>

        <div class="alert alert-warning"
             v-if="!listExists">
            No items currently in list - go back to previous step to add list items.
        </div>

        <div v-if="listExists">
            <div class="mt-2">
                Current Sample Size: {{sampleSize}}
            </div>
            <b-form-input required
                          number
                          type="range"
                          min="1"
                          :max="sampleMax"
                          v-model="sampleSize">
            </b-form-input>
        </div>

    </div>
</template>

<script>
import Vue from 'vue'
import ToolMixin from '@/providers/ToolMixin'

export default Vue.extend({
    name: "ListGeneratorStep1",
    mixins: [ToolMixin],
    computed: {
        listExists() {
            return this.docData.listText && this.docData.listText.length > 0
        },
        sampleMax() {
            return this.docData.listText.split(/\r?\n/).length
        },
        thisStepIsValid() {
            return this.docData.sampleSize
        },
        sampleSize: {
            get() {
                return this.docData.sampleSize
            },
            set(newSize) {
                Vue.set(this.docData, 'sampleSize', newSize)
            }
        }
    }
})

</script>